import React, { useState } from "react";
import {
  Box,
  Card,
  CardActions,
  CardContent,
  Typography,
  Tooltip
} from "@mui/material";
import CollectionsIcon from "@mui/icons-material/Collections";
import TextButtonComponet from "../../atom/Buttons/TextButton";
import pdfThumbnail from "../../../assets/Images/file_thumbnail.jpg";
import { resolveDocumentThumbnailSrc, safeBuildThumbnailUrl} from "../../../core/Constant";
import FolderThumb from "../../../assets/Images/folder_thumb.png";

const DocumentCard = ({
  title,
  btnText,
  isFolder = false,
  onViewDocument = () => {},
  isImage = false,
  item,
  isDisabled = false,
  classStyle = "btn btn-primary",
  baseUrl = ""
}) => {
  const [imageError, setImageError] = useState(false);

  const getCardThumbnailSrc = () => {
    const apiThumb = typeof item === "object" ? (item?.thumbnail || item?.thumbnail_url) : null;
    const resolvedSrc = resolveDocumentThumbnailSrc(apiThumb, { isFolder, isImage });

    if (!resolvedSrc) {
      return null;
    }
    return safeBuildThumbnailUrl(baseUrl, resolvedSrc);
  };

  const dynamicThumbnailSrc = getCardThumbnailSrc();

  return (
    <Card
      sx={{
        width: 280,
        borderRadius: "24px",
        overflow: "hidden",
        border: "1px solid #E5E5E5",
        boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0px 8px 20px rgba(0,0,0,0.12)",
        },
      }}
    >
      <Box
        sx={{
          height: 220,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#FAFAFA",
          p: 3,
        }}
      >
        <Box
          sx={{
            width: 210,
            height: 210,
            borderRadius: "24px",
            backgroundColor: "#FAFAFA",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden"
          }}
        >
          {/* Priority 1 & 2: Dynamic Image (API or LocalStorage config) */}
          {dynamicThumbnailSrc && !imageError ? (
            <Box
              component="img"
              src={dynamicThumbnailSrc}
              alt={title || "Thumbnail"}
              onError={() => setImageError(true)}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                p: 1,
              }}
            />
          ) : isFolder ? (
            /*  Folder Icon */
            <Box
              component="img"
              src={FolderThumb}
              alt={title || "Folder Thumbnail"}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                p: 1,
              }}
            />
          ) : isImage ? (
            /* Image File Icon */
            <CollectionsIcon
              sx={{
                fontSize: 90,
                color: "#9834F0",
              }}
            />
          ) : (
            /* Static Asset PDF Thumbnail */
            <Box
              component="img"
              src={pdfThumbnail}
              alt="PDF Thumbnail"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                p: 1,
              }}
            />
          )}
          </Box>
      </Box>
      <CardContent>
          <Tooltip title={title} arrow placement="bottom">
            <Typography
              align="center"
              sx={{
                color: "#8C8C8C",
                fontWeight: 700,
                fontSize: 18,
                display: "block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                cursor: "pointer",
              }}
            >
              {title}
          </Typography>
          </Tooltip>
      </CardContent>
      <CardActions>
        <TextButtonComponet onButtonClick={onViewDocument} text={btnText} isDisabled={isDisabled} classStyle={classStyle} />
      </CardActions>
    </Card>
  );
};

export default DocumentCard;
